/**
 * @generated SignedSource<<575581e79484a121c234da2161f7b860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SponsorsSectionSponsor_guildSponsorship$data = {
  readonly darkModeImage: {
    readonly height: number | null | undefined;
    readonly transformUrl: string;
    readonly width: number | null | undefined;
  } | null | undefined;
  readonly description: string;
  readonly guild: {
    readonly name: string;
  } | null | undefined;
  readonly lightModeImage: {
    readonly height: number | null | undefined;
    readonly transformUrl: string;
    readonly width: number | null | undefined;
  } | null | undefined;
  readonly linkText: string;
  readonly rowId: string;
  readonly webUrl: string;
  readonly " $fragmentType": "SponsorsSectionSponsor_guildSponsorship";
};
export type SponsorsSectionSponsor_guildSponsorship$key = {
  readonly " $data"?: SponsorsSectionSponsor_guildSponsorship$data;
  readonly " $fragmentSpreads": FragmentRefs<"SponsorsSectionSponsor_guildSponsorship">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "transform",
        "value": {
          "dpr": 3,
          "fit": "contain",
          "fo": "left",
          "h": 80,
          "w": 150
        }
      }
    ],
    "kind": "ScalarField",
    "name": "transformUrl",
    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"contain\",\"fo\":\"left\",\"h\":80,\"w\":150})"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SponsorsSectionSponsor_guildSponsorship",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "lightModeImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "darkModeImage",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Guild",
      "kind": "LinkedField",
      "name": "guild",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildSponsorship",
  "abstractKey": null
};
})();

(node as any).hash = "7000b6c5333f740d83302fc83622622d";

export default node;
